// * applicationService.js
import apiManager from './apiManager';

const createApplication__public = async (createObj) => {
    apiManager.axios.defaults.timeout = 20000;
    apiManager.axios.defaults.headers.post['Content-Type'] =
        'multipart/form-data';

    const formData = new FormData();

    Object.keys(createObj).map((key) => {
        formData.append(key, createObj[key]);
        return key;
    });

    const createApplication = await apiManager.axios
        .post(`/v1/public/application`, formData)
        .then((response) => {
            return {
                status: response.status,
                data: response.data,
            };
        })
        .catch((err) => {
            return {
                status: err.status.data,
                data: null,
            };
        });

    return createApplication;
};

const fetchApplication = async (id) => {
    const application = await apiManager.axios
        .get(`/v1/admin/applications/${id}`)
        .then((response) => {
            return {
                status: response.status,
                data: response.data.data,
            };
        })
        .catch((e) => {
            return {
                status: e.response.status,
                data: null,
            };
        });

    return application;
};

const applicationService = { createApplication__public, fetchApplication };

export default applicationService;
